// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.u2kVRhlWz8wfA_XBNe3H{flex-direction:column;flex-grow:1;height:100%;display:flex}.RbZDwESEnkcSViFg9SJS{padding-left:12px}.z7i4kmqw_LkX0vreeFpz{flex-grow:1;margin-left:16px;display:flex;position:relative}.lx7FRYi50wG65azejZTX{margin-right:4px}.p8aJQ8paE2o7IoxWwt7l{align-items:center;gap:10px;width:100%;min-width:0;display:flex}.p8aJQ8paE2o7IoxWwt7l :has(.j_DbxuKm3wEQftEZLaGt){min-width:0}.j_DbxuKm3wEQftEZLaGt{min-width:0}.K0jrvWui1o4eX8pBoJJ8{flex:none;margin-left:auto;margin-right:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `u2kVRhlWz8wfA_XBNe3H`,
	"search": `RbZDwESEnkcSViFg9SJS`,
	"table": `z7i4kmqw_LkX0vreeFpz`,
	"inboxCellContainer": `lx7FRYi50wG65azejZTX`,
	"nameCellWrapper": `p8aJQ8paE2o7IoxWwt7l`,
	"nameText": `j_DbxuKm3wEQftEZLaGt`,
	"nameToggle": `K0jrvWui1o4eX8pBoJJ8`
};
export default ___CSS_LOADER_EXPORT___;
